import React, { useContext } from "react";
import { Stores, StoresContext } from "Globals/Stores";
import { PrivateRoute } from "Globals/Views/PrivateRoute";
import * as RouterUtil from "Utils/Routing";
import { StoresInstance } from "Globals/Stores";
import { AppUrls } from "AppUrls";
import { ClientDetailView } from "./ClientDetailView";
import { ClientListView } from "./ClientListView";
import { DarwinLayout } from "Globals/Views/Layouts/DarwinLayout";

export const ClientRoutes: React.FC = () => {
    function getRootLayout() {
        return DarwinLayout;
    }

    const store = useContext<Stores>(StoresContext);
    return (
        <>
            <PrivateRoute
                exact
                path={AppUrls.Client.Admin.Client.Add}
                component={ClientListView}
                isAllowed={() => {
                    return store.Domain.AccountStore.IsLoggedIn && RouterUtil.requireAdminLogin(StoresInstance);
                }}
                layout={getRootLayout()}
            />
            <PrivateRoute
                exact
                path={AppUrls.Client.Admin.Client.List}
                component={ClientListView}
                isAllowed={() => {
                    return store.Domain.AccountStore.IsLoggedIn && RouterUtil.requireAdminLogin(StoresInstance);
                }}
                layout={getRootLayout()}
            />
            <PrivateRoute
                exact
                path={AppUrls.Client.Admin.Client.Detail}
                component={ClientDetailView}
                isAllowed={() => {
                    return store.Domain.AccountStore.IsLoggedIn && RouterUtil.requireAdminLogin(StoresInstance);
                }}
                layout={getRootLayout()}
            />
            <PrivateRoute
                exact
                path={AppUrls.Client.Admin.Client.Edit}
                component={ClientDetailView}
                isAllowed={() => {
                    return store.Domain.AccountStore.IsLoggedIn && RouterUtil.requireAdminLogin(StoresInstance);
                }}
                layout={getRootLayout()}
            />
        </>
    );
};
